// src/pages/admin/{Notice1FormForm.js
import React from "react";
import FormWrapper from "../../forms/shared/FormWrapper";
import Notice4Form from "../../forms/anounce/Notice-of-Dissolution-4th-Publication/NoticeofDissolution4thPublication";

function Notice4Page() {
  return (
    <FormWrapper
      title="เลิกบริษัทประกาศเลิกขั้นตอนที่4-เสร็จชำระบัญชี"
      FormComponent={Notice4Form}
      formKey="notice-dissolution-4th" // key ไว้แยกชื่อไฟล์รูป/เก็บ localStorage ถ้ามี
    />
  );
}

export default Notice4Page;
